module.exports = __webpack_public_path__ + "static/img/轴向模数方式蜗杆蜗轮的计算.06fa85ba.jpg";